"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyPointHaloOptions = void 0;
// (C) 2007-2020 GoodData Corporation
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function applyPointHaloOptions(Highcharts) {
    Highcharts.wrap(Highcharts.Point.prototype, "setState", function setState(proceed) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var tmp = this.series.options.states.hover.halo;
        this.series.options.states.hover.halo = this.halo || this.series.options.states.hover.halo;
        proceed.apply(this, args);
        this.series.options.states.hover.halo = tmp;
    });
}
exports.applyPointHaloOptions = applyPointHaloOptions;
//# sourceMappingURL=pointHalo.js.map